import { createContext } from 'react';

const ListingContext = createContext<{
  listingId: null | string;
}>({
  listingId: null
});

export default ListingContext;
